
<div *ngIf="creditKbaOnboardingEnabled" class="content-layout" [brightsideWebFb]="{ event_name: 'credit_kba_shown' }">
  <bw-action-article-legacy>
    <ui-nav-exit-back *ngIf="!pageFromFullLayout" back-action-top [trackingDetail]="{ event_name: 'credit_kba_dismissed' }"></ui-nav-exit-back>
    <ui-nav-exit-back *ngIf="pageFromFullLayout" back-action-bottom [trackingDetail]="{ event_name: 'credit_kba_dismissed' }"></ui-nav-exit-back>

    <div header-title class="mb-md">
      <typography-legacy *ngIf="!areQuestionsLoading && currentQuestion.field_label" title-medium>
        {{ currentQuestion.field_label }}
      </typography-legacy>
    </div>

    <div content-section>
      <bw-spinner-legacy brightsideWebTimeout *ngIf="areQuestionsLoading; else questionDisplay"></bw-spinner-legacy>

      <ng-template #questionDisplay>
        <form [formGroup]="questionForm">
          <div *ngFor="let choice of currentQuestion.choices; let i = index">
            <bw-radio-legacy
              name="questionAnswer"
              formControlName="questionAnswer"
              [value]="currentQuestion.answerIdMapping[choice]"
              [label]="choice"
            ></bw-radio-legacy>
          </div>
        </form>
      </ng-template>
    </div>

    <div *ngIf="!areQuestionsLoading" footer-actions class="flex-row row-reverse">
      <button
        bw-button-legacy
        type="submit"
        [brightsideWebFb]="{ event_name: 'credit_kba_tapped', action: 'click' }"
        [disabled]="processing || questionForm.invalid"
        [processing]="processing"
        (click)="handleCtaClick()">
        {{ 'BUTTON_CONTINUE' | translate }}
      </button>
    </div>
  </bw-action-article-legacy>
</div>

<bw-modal-legacy
  *ngIf="showErrorModal"
  modalWidth="medium"
  [brightsideWebFb]="{ event_name: 'error_shown', custom: { 'error id': 'credit_kba'}}">
  <typography-legacy title-medium>{{ 'ERROR_KBA_FAILED_TITLE' | translate }}</typography-legacy>
  <typography-legacy class="body" text-large-regular color="var(--secondary-text)">
    {{ 'ERROR_KBA_FAILED_ONBOARDING_FIRST' | translate }}
  </typography-legacy>
  <div class="footer flex-row row-reverse">
    <button
      bw-button-legacy
      (click)="handleRetryCtaClick()"
      [processing]="isLoadingQuestions">
      {{ 'RETRY' | translate }}
    </button>
    <a
      bw-anchor-legacy
      class="bs-blue pr-xl"
      (click)="handleCancelCtaClick(false)">
      {{ 'CONNECT_LATER' | translate }}
    </a>
  </div>
</bw-modal-legacy>

<bw-modal-legacy
  *ngIf="showErrorNoRetryModal"
  modalWidth="medium"
  [brightsideWebFb]="{ event_name: 'error_shown', custom: { 'error id': 'credit_kba'}}">
  <typography-legacy title-medium>{{ 'ERROR_KBA_FAILED_TITLE' | translate }}</typography-legacy>
  <typography-legacy class="body" text-large-regular color="var(--secondary-text)">
    {{ 'ERROR_KBA_FAILED_ONBOARDING' | translate }}
  </typography-legacy>
  <div class="footer flex-row row-reverse">
    <button
      bw-button-legacy
      (click)="handleCancelCtaClick(false, true)"
      [processing]="isLoadingQuestions">
      {{ 'BUTTON_CONTINUE' | translate }}
    </button>
  </div>
</bw-modal-legacy>

<bw-modal-legacy
  *ngIf="!creditKbaOnboardingEnabled"
  modalWidth="medium"
  [brightsideWebFb]="{ event_name: 'credit_kba_skipped'}">
  <typography-legacy title-medium>{{ 'ERROR_KBA_FAILED_TITLE' | translate }}</typography-legacy>
  <typography-legacy class="body" text-large-regular color="var(--secondary-text)">
    {{ 'ERROR_CREDIT_FAILED_NO_KBA_DESC' | translate }}
  </typography-legacy>
  <div class="footer flex-row row-reverse">
    <button
      bw-button-legacy
      (click)="handleCancelCtaClick(false, true)"
      [processing]="isLoadingQuestions">
      {{ 'BUTTON_CONTINUE' | translate }}
    </button>
  </div>
</bw-modal-legacy>
